<script>
import { addWhiteBoardMenu, addLandingPage } from './modules/landingPage'
import { addClientPage, openClientPage } from './modules/clientsPage'
import { setMeeting,createRightMenuOptions, createHeaderIcons, endcall, endParticipant, kickOutParticipant,startRecording, stopRecording,startMedia } from './modules/iconManager'
import { addToHistory } from './modules/history'
import {   createRootMenu } from './modules/rootMenu'
import { mediaPlayer } from './modules/mediaPlayer'
import { watch, ref, nextTick, onMounted  } from 'vue'
import { deviceStore } from './stores/deviceStore'
//import { Subject } from 'rxjs';
import Containers from './components/DeviceManager.vue'
import { useDraggable } from '@vueuse/core'
import  FullScreenHeader from './components/FullScreenHeader.vue'
import * as oxygenUtil from './components/SimpliaV2Components/OxygenUtil/oxygenutil.js';
import $ from 'jquery';
import  MeetingPopup from './components/saveMeetingPopup.vue'
import  PhoneNumberPopup from './components/forwardSettingsV1.vue'
import  EmailAddressPopup from './components/saveEmailAddressPopup.vue'
//import  OxygenNumberPopup from './components/saveOxygenNumberPopup.vue'
import  meetinginfopopup from './components/meetingInfo.vue'
import  watchmeetinginfopopup from './components/watchmeetingInfo.vue'
import  deviceStream from './components/deviceStream.vue'
import  deskList from './components/desklistpopup.vue'
import ImportTable from  './components/ImportTablepopup.vue'
import  DeepLinkPopup from './components/createDeepLinkPopup.vue'
import  PublishingLink from './components/simpliaPublishingLink.vue'
import  meetingLinks from './components/meetingLinks.vue'
import contextinfopopup from './components/contextInfo.vue'
import SwitchRolePopup from './components/switchRolePopup.vue'
import { getBehaviours , addglobalBehaviours ,setEmbeddedBehaviours,GetNodeDeskGraph} from './modules/behaviour'
import { ConfirmAgreement,ConfirmRTablePost,CreateConversationPost,getProviderDatatoCall,getAgreementInfo,grantTransaction,ConfirmGlobalAgreement } from './modules/marketplace'
import { extractFromGSheet } from './modules/googleSheets'

var Gstore = null;

const RTABLESERVER = '_FFFFFFFFFFFFFF00001713960477110008_';

export default {
  components: {
      Containers,
      FullScreenHeader,
      MeetingPopup,
      PhoneNumberPopup,
      EmailAddressPopup,
      /*OxygenNumberPopup,*/
      meetinginfopopup,
      watchmeetinginfopopup,
      deviceStream,
      deskList,
      ImportTable,
      DeepLinkPopup,
      PublishingLink,
      meetingLinks,
      contextinfopopup,
      SwitchRolePopup
   },
  data: () => ({
      crmList : []
  }),
  methods: {
      addViewPort : function(viewPort) {
        window.devStore.addViewPort(viewPort);
      },
      addHeaderIcon : function(viewPort) {
        window.devStore.addViewPort(viewPort);
      },
      addRightMemu: function(viewportID, rightMemu) {
        window.devStore.addRightMemu(viewportID, rightMemu);
      },
      setEmbeddedBehaviour : function(clientID,behaviourObj) {
          setEmbeddedBehaviours(clientID,behaviourObj,window.devStore);
      },
      addBehavioursHistory : function(client, behaviour, params) {
        console.log("addglobalBehaviours function called",client, behaviour, params, window.devStore);
        addglobalBehaviours(client, behaviour, params, window.devStore);
      },
      addEmailonMessageBox: function(viewportID,email) {
        console.log("addEmailonMessageBox",viewportID,email);
        window.devStore.addEmailonMessageBox(viewportID,email);
      },
      addPhoneonMessageBox: function(viewportID,phone) {
        window.devStore.addPhoneonMessageBox(viewportID,phone);
      },
      addLeftRibbonIcon: function(viewportID,params) {
        window.devStore.addLeftRibbonIcon(viewportID,params);
      },
      addRightRibbonIcon: function(viewportID,params) {
        window.devStore.addRightRibbonIcon(viewportID,params);
      },
      updateIconInfo: function(viewportID,params) {
        window.devStore.updateIconInfo(viewportID,params);
      },
      hideRibbonIcon: function(viewportID,params) {
        window.devStore.hideRibbonIcon(viewportID,params);
      },
      showRibbonIcon: function(viewportID,params) {
        window.devStore.showRibbonIcon(viewportID,params);
      },
      changeRibbonIconColor: function(viewportID,params) {
        window.devStore.changeRibbonIconColor(viewportID,params);
      },
      setCurrentState: function(thread,subject,state) {
        console.log("set current state"+thread+"==="+subject+"==="+state);
        window.devStore.setCurrentState(thread,subject,state);
      },
      addBehaviour: function(thread,subject,behaviourObj) {
        window.devStore.addBehaviours(thread,subject,behaviourObj);
      },
      regBehariourEventHandlers : function(thread,subject, EventHandlers) {
        console.log("register event handler got:",thread,subject,EventHandlers);
        window.devStore.regBehaviourEventHandlers(thread,subject,EventHandlers);
      },
      saveFormData: function(thread,subject,FormData) {
        window.devStore.saveFormData(thread,subject,FormData);
      },
      RegisterToHistory: function(client,behaviour,params,callback) {
          addToHistory(client,behaviour,params,window.devStore,callback);
      },
      getCrmInfo : function(clientID, callback) {
        let bpmnComponentTipId = '_FF00321822120916427824957001562784_';
        var client = window.botStore.getClientByID(clientID);
        console.log("main home page client",client);

        let GrantPath = JSON.parse(client.ClientContext);
        let GrantPE = GrantPath.GrantPE;
        let currentContext = JSON.parse(client.CurrentContext);
        let requestContext = currentContext;
        let LocationContext = JSON.parse(client.LocationContext);

        let params = {
           componentId : bpmnComponentTipId,
           command : "getCrmList",
           data : requestContext,
           Type : 'BotApi'
         };
         this.crmList =[];
         let defaultcrmVal = {};
         defaultcrmVal.value = "_FFFFFFFFFFFFFF00001668203009117626_";
         defaultcrmVal.text =  "Simplia CRM";
         this.crmList.push(defaultcrmVal);

         window.BotServices.callComponent(params, (err, result) => {
           if(result) {
             console.log("===result crmList getComponents=======",result);
             result.forEach((crm) => {
                 let crmVal = {};
                 crmVal.value = crm.GrantRightID;
                 crmVal.text =  crm.GrantRightDN;
                 this.crmList.push(crmVal);
             });
             console.log("crmList",this.crmList);
             callback(null, this.crmList);
           } else {
              callback(null, this.crmList);
           }
         });
      },
      getTableTemplates : function(clientID, params,callback) {
        let marketpaceServer = '_FFFFFFFFFFFFFF00001689753917693088_';
        var client = window.botStore.getClientByID(clientID);
        console.log("main home page client",client.ClientRightRole,"------",params);

        let GrantPath = JSON.parse(client.ClientContext);
        let GrantPE = GrantPath.GrantPE;
        let currentContext = JSON.parse(client.CurrentContext);
        let requestContext = currentContext;
        let LocationContext = JSON.parse(client.LocationContext);
        console.log("marketplace grantpe :,"+GrantPE);
        
        requestContext.TableID = "_FFFFFFFFFFFFFF00001731965965540235_";

        if(client.ClientRightRole == "Customer") {
          requestContext.TemplateRole = "Editor"; 
        } else {
          requestContext.TemplateRole = "Editor";
        }
        if(params && (params.Action == "OfferService" && params.ActionType == "Post" && client && (client.ClientRightRole == "Provider" || client.ClientRightRole == "admin")) || (params.Action == "RequestService" && params.ActionType == "Post" && client && client.ClientRightRole == "Customer")) {
          let params = {
              componentId : marketpaceServer,
              command : "getPostTemplates",
              data : requestContext,
              Type : 'BotApi'
            };
            this.templateList =[];
            
            window.BotServices.callComponent(params, (err, result) => {
              if(result) {
                console.log("getPostTemplates Got:",result);
                result.forEach((crm) => {
                    let crmVal = {};
                    crmVal.value = crm.ComponentID+'/'+crm.GrantPE;
                    crmVal.text =  crm.DisplayName;
                    this.templateList.push(crmVal);
                });
                console.log("rtable templateList :",this.templateList);
                callback(null, this.templateList);
              } else {
                callback(null, this.templateList);
              }
            }); 
        } else {
          let defaultcrmVal = {};
          this.customercrmList = []; 
          //defaultcrmVal.value = "_FFFFFFFFFFFFFF00001668203009117626_";
           //defaultcrmVal.text =  "Simplia CRM";
           defaultcrmVal.value = "_FFFFFFFFFFFFFF00001689753917693106_";
           defaultcrmVal.text =  "MarketPlacePost-0036";
           this.customercrmList.push(defaultcrmVal);
           callback(null, this.customercrmList);
        }
        
      },
      GetCSVHeaders : function(params,callback) {
        console.log("GetCSVHeaders Got :",params);
        let clientObj = window.botStore.getClientByID(params.ClientID);
        console.log("GetCSVHeaders client :",clientObj);
        
        let currentContext = JSON.parse(clientObj.CurrentContext);
        //currentContext.atComponent.Node
        
        let CreateRTableParams = {
              componentId: RTABLESERVER,
              command: "GetCSVHeaders",
              data: { "Context": currentContext},
              Type: 'BotApi'
            }
        window.BotServices.callComponent(CreateRTableParams, (err, result) => {
          console.log("GetCSVHeaders API Got : ", result);
          if(result) {
            callback(null, result);
          } else {
            console.log("GetCSVHeaders Got Error: ", err);
            callback(err, null);
          }
        });
      },
      SetUploadCSVData: function(headers, params,callback) {
        console.log("SetUploadCSVData Got :",headers,"===data==",params);
        
        let clientObj = window.botStore.getClientByID(params.ClientId);
        let currentContext = JSON.parse(clientObj.CurrentContext);
        let data = {"ClientID":params.ClientId,"DisplayName":params.DisplayName};
        let GrantPath = JSON.parse(clientObj.ClientContext);
        let GrantPE = GrantPath.GrantPE;

        if(params.ListType == "Current") {
          let columnsdata = {"ClientID":params.ClientId,"DisplayName":params.DisplayName,"Headers":headers,"TableId":clientObj.ClientRight,"TableName":clientObj.ClientRightDN,"RowData":params,"ListType":params.ListType};
  
          this.AddRows(columnsdata,(err,rowres) => {
            if(rowres) {
              console.log("add row api got : ", rowres);
              if(rowres == "Row Added") {
                window.BotServices.PullPE(
                    {
                      ByClientID : params.ClientId,
                      InitialContext : {
                        ByClientID : params.ClientId
                      },
                      OpenPE : GrantPE
                    }
                  );
                  console.log("Data Uploaded Successfully");
              }
            } else {
              console.log("add row api got error: ", err);
            }
          });
        } else {
          this.CreateTable(data,(err,result) => {
            if(result) {
              if(result && result.GrantItem) {
                //this.InitTable(data, (err,resVal) => {
                  //if(resVal && resVal == "Inited") {
                    let columnsdata = {"ClientID":params.ClientId,"DisplayName":params.DisplayName,"Headers":headers,"TableId":result.NewTable.Node,"TableName":result.NewTable.DisplayName,"RowData":params,"ListType":params.ListType};
  
                    this.AddColumns(columnsdata, (err,res) => {
                      if(res) {
                        console.log("add column api got : ", res);
                        if(res == "Added") {
                          
                            this.AddRows(columnsdata,(err,rowres) => {
                              if(rowres == "Row Added") {
                                console.log("add row api got : ", rowres);
                                window.BotServices.PullPE(
                                  {
                                    ByClientID : params.ClientId,
                                    InitialContext : {
                                      ByClientID : params.ClientId
                                    },
                                    OpenPE : result.GrantItem.GrantPE
                                  }
                                );
                              } else {
                                console.log("add row api got error: ", err);
                              }
                            });
                        }
                      }
                    });
                  //}
                //});
              }
            }
          });
        }
      },
      CreateTable : function(params,callback) {
        let clientObj = window.botStore.getClientByID(params.ClientID);
        let currentContext = JSON.parse(clientObj.CurrentContext);
        //currentContext.atComponent.Node
        let data = {"ClientID":params.ClientID,"DisplayName":params.DisplayName};
        
        let CreateRTableParams = {
              componentId: RTABLESERVER,
              command: "CreateTable",
              data: { "currentContext": currentContext, "DisplayNamePrefix": params.DisplayName, "TemplateOID": clientObj.ClientRight},
              Type: 'BotApi'
            }
            window.BotServices.callComponent(CreateRTableParams, (err, result) => {
              console.log("CreateTable API Got : ", result);
              if(result) {
                callback(null, result);
              } else {
                console.log("CreateTable Got Error: ", err);
                callback(err, null);
              }
            });
      },
      InitTable : function(params, callback) {
        let clientObj = window.botStore.getClientByID(params.ClientID);
        let currentContext = JSON.parse(clientObj.CurrentContext);
        
        let tblparams = {
          componentId: RTABLESERVER,
          command: "InitTable",
          data: { "Context": currentContext },
          Type: 'BotApi'
        }
        window.BotServices.callComponent(tblparams, (err, result) => {
          if(result) {
            console.log("InitTable Api Got : ", result);
            callback(null, "Inited");
          } else {
            console.log("InitTable Api Got error: ", err);
            callback(err, null);
          }
        });  
      },
      AddColumns : function(params, callback) {
        let clientObj = window.botStore.getClientByID(params.ClientID);
        let currentContext = JSON.parse(clientObj.CurrentContext);
        let headersCount = params.Headers.length;
        let i=1;let ColumnArr = [];
        params.Headers.forEach((column) => {
          ColumnArr.push({"FieldName": column, "FieldType": "String"});
        });
        let AddColumnSchemaParams = {
          componentId: RTABLESERVER,
          command: "AddColumns",
          data: { "Context": currentContext,"Columns":ColumnArr ,"Formulas": "",Methods:"","TableId":params.TableId,"TableName":params.TableName},
          Type: 'BotApi'
        }
        console.log("AddColum params :",AddColumnSchemaParams);

        window.BotServices.callComponent(AddColumnSchemaParams, (err, result) => {
          console.log("AddColumn Got : ", result);
          if(result) {
            callback(null,"Added");
          } else {
            //callback(err,null);
            console.log("AddColumn Got error: ", err);
          }
        });
      },
      AddRows : function(params , callback) {
        let clientObj = window.botStore.getClientByID(params.ClientID);
        let currentContext = JSON.parse(clientObj.CurrentContext);
        let headersCount = params.RowData.Data.length;
        let i=1;
        
        let AddRowparams = {
              componentId: RTABLESERVER,
              command: "AddRows",//"UploadCSVData", 
              data: { "Context": currentContext, "Rows": params.RowData.Data,"TableId":params.TableId,"TableName":params.TableName,"DisplayName":"Row","RowID":"","ListType":params.ListType},
              Type: 'BotApi'
            }
            console.log("AddRows params :",AddRowparams);

            window.BotServices.callComponent(AddRowparams, (err, result) => {
        
              console.log("AddRow Got : ", result);
              if(result) {
                console.log("AddRow data api Got : ", result);
                callback(null,"Row Added");
              }  else {
                console.log("AddRow data api Got error: ", err);
                callback(error,null);
              }
            });

      },
      AddRow : function(params , callback) {
        let clientObj = window.botStore.getClientByID(params.ClientID);
        let currentContext = JSON.parse(clientObj.CurrentContext);
        //let headersCount = params.RowData.Data.length;
        let i=1;
        params.Context =  currentContext;
        params.RowID = '0';
        params.Row = params.RowData;
        params.DeskInit = {Node: params.DeskName, Behaviour : {Role : params.DeskRole , Action : params.DeskAction, Result : params.DeskRole +':' + params.DeskAction +'/'+ params.DeskResult}};
        
        let AddRowparams = {
          componentId: RTABLESERVER,
          command: "AddRow",
          //data: { "Context": currentContext, "Row": params.RowData,"TableId":params.TableId,"TableName":params.TableName,"DisplayName":"Row","RowID":"0"},
          data : params,
          Type: 'BotApi'
        }
        console.log("AddRow params :",AddRowparams);

        window.BotServices.callComponent(AddRowparams, (err, result) => {
    
          console.log("AddRow Got : ", result);
          if(result) {
            console.log("AddRow data api Got : ", result);
            callback(null,result);
          }  else {
            console.log("AddRow data api Got error: ", err);
            callback(err,null);
          }
        });
    
      },
      SetTableData: function(paramsObj,callback) {
        console.log("SetTableData Got :",paramsObj);
        let clientId = paramsObj.ClientId;
        let crmTemplateId = paramsObj.TemplateId;
        let MasterProviderArr = paramsObj.Data;
        let DisplayName = paramsObj.DisplayName;

        //{ClientId : this.clientId, TemplateId: this.crmTemplateId, Data : data, DisplayName : ''}
            console.log("Got event for SetTableData",clientId,"===",crmTemplateId,"====",MasterProviderArr+"==="+DisplayName);
            var client = window.botStore.getClientByID(clientId);
            console.log("main home page client",client);

            let GrantPath = JSON.parse(client.ClientContext);
            let GrantPE = GrantPath.GrantPE;
            let currentContext = JSON.parse(client.CurrentContext);
            let requestContext = JSON.parse(JSON.stringify(currentContext));
            let LocationContext = JSON.parse(client.LocationContext);
            requestContext.CRMTemplateId = "_FFFFFFFFFFFFFF00001718807520460075_";
            requestContext.MasterProviderArr = MasterProviderArr;
            requestContext.ProcessTemplateId = "_FFFFFFFFFFFFFF00001669209873678382_";
            //GraphTemplateID = "_FFFFFFFFFFFFFF00001718816820894073_"
            requestContext.DisplayName = DisplayName;

            let dialerComponentTipId = '_FF04903722417116963400679848891656_';
            let params = {
                ComponentId: dialerComponentTipId,
                Command: "CreateList",//"InsertProviderData",
                Data: requestContext,
                Type: 'BotApi'
             }
              console.log("CreateList params",params);
              window.BotServices.callComponent(params, (err, result) => {
              if (result && result.PullPE) {
                console.log("CreateList Got :", result);
                window.BotServices.PullPE(
                {
                  ByClientID : client.Client,
                  InitialContext : {
                    ByClientID : client.Client
                  },
                  OpenPE : result.PullPE
                }
            );
                callback(null, result);
              } else {
                callback(null, result);
              }
            });
      },
      SetProviderData: function(paramsObj,callback) {
        let clientId = paramsObj.ClientId;
        let crmTemplateId = paramsObj.TemplateId;
        let MasterProviderArr = paramsObj.Data;
        let DisplayName = paramsObj.DisplayName;

        //{ClientId : this.clientId, TemplateId: this.crmTemplateId, Data : data, DisplayName : ''}
            console.log("Got event for SetProviderData",clientId,"===",crmTemplateId,"====",MasterProviderArr+"==="+DisplayName);
            var client = window.botStore.getClientByID(clientId);
            console.log("main home page client",client);

            let GrantPath = JSON.parse(client.ClientContext);
            let GrantPE = GrantPath.GrantPE;
            let currentContext = JSON.parse(client.CurrentContext);
            let requestContext = JSON.parse(JSON.stringify(currentContext));
            let LocationContext = JSON.parse(client.LocationContext);
            requestContext.CRMTemplateId = crmTemplateId;
            requestContext.MasterProviderArr = MasterProviderArr;
            requestContext.ProcessTemplateId = "_FFFFFFFFFFFFFF00001669209873678382_";
            requestContext.DisplayName = DisplayName;

            //let bpmnComponentTipId = '_FF00321822120916427824957001562784_';
            let bpmnComponentTipId ='_FF05220204411516967738046906429514_';
            let params = {
                //componentId: "_FFFFFFFFFFFFFF00001669740131169112_",
                componentId: '_FF05220204411516967738046906429514_',
                command: "addProviderList",//"InsertProviderData",
                data: requestContext,
                Type: 'BotApi'
             }
              console.log("addProviderList params",params);
              window.BotServices.callComponent(params, (err, result) => {
              if (result) {
                console.log("Followup callComponent result", result);
                callback(null, result);
              } else {
                callback(null, result);
              }
            });
      },
      postToHistory(params,reply,callback) {
        let marketpaceServer = '_FFFFFFFFFFFFFF00001689753917693088_';
        
        let historyParams= {};
        historyParams.EventTemplate = params.EventTemplate;
        historyParams.EventRegistrant = params.EventRegistrant;
        historyParams.Label = "Message";
        historyParams.NoteTemplateID = params.NoteTemplateID;
        historyParams.ToPE = params.ToPE;
        historyParams.ByPE = params.ByPE;
        historyParams.Note = {String: reply, Link : ''};
        historyParams.GrantID = params.GrantID;
        historyParams.AttributionID = params.AttributionID;
        historyParams.RootEventID = params.RootEventID;
        historyParams.CausingEventID = params.CausingEventID;
        console.log('Marketplace AI Provider Desk: Notify Event Post create post', historyParams);
        
        let paramsObj = {
            componentId : marketpaceServer,
            command : "mpPostHistory",
            data : historyParams,
            Type : 'BotApi'
        };
        
        window.top.BotServices.callComponent(paramsObj, (err, result) => {
            if(result) {
                console.log("marketplace ai mpPostHistory Got:",result);
            } else {
                console.log("marketplace ai mpPostHistory Got err:",err);
            }
            callback(err,result);
        }); 
      },
      showIcon(clientId, iconId) {
        let viewPorts = window.devStore.getViewportsByClient(clientId);
        if(viewPorts && viewPorts.length > 0) {
          viewPorts.forEach((viewPort) => {
             window.devStore.showRibbonIcon(viewPort.viewportID,{"iconId":iconId});
          });
        }
      },
      hideIcon(clientId, iconId){
        let viewPorts = window.devStore.getViewportsByClient(clientId);
        if(viewPorts && viewPorts.length > 0) {
          viewPorts.forEach((viewPort) => {
               window.devStore.hideRibbonIcon(viewPort.viewportID,{"iconId":iconId});
          });
        }
      },
      createPlaySoundElement(id) {
          let soundPlayback = "soundPlayback"+ id;
          let soundSource = "soundSource"+ id;
          var soundpaneldiv = '<div style="display:none;"><audio id="'+soundPlayback+'" autoplay><source id="'+soundSource+'" type="audio/mp3" src=""></audio></div>';
          var t = document.getElementById("mediaElements");
          t.innerHTML = soundpaneldiv;
      },
      playSoundFile(data) {
          let soundPlayback = "soundPlayback"+ data.id;
          let soundSource = "soundSource"+ data.id;
          document.getElementById(soundSource).src = data.soundFile;
          document.getElementById(soundPlayback).autoplay = true;
          document.getElementById(soundPlayback).load();
      },
      pauseSoundFile(data) {
          let soundPlayback = "soundPlayback"+ data.id;
          let soundSource = "soundSource"+ data.id;
          document.getElementById(soundSource).src = "";
          document.getElementById(soundPlayback).pause();
          document.getElementById(soundPlayback).autoplay = false;
          document.getElementById(soundPlayback).load();
      },
      showFullscreen: function(viewPort) {
        let fullscreen = document.getElementById(viewPort);
          if (!document.fullscreenElement) {
            fullscreen?.requestFullscreen();
          } else {
            document.exitFullscreen();
          }
      },
      exitFullscreen: function(viewPort) {
        let fullscreen = document.getElementById(viewPort);
        document.exitFullscreen();
      },
      maximizeWindow: function(viewPort) {
          let viewportWin = window.document.getElementById(viewPort);
          console.log("Got viewport Element:",viewportWin);
          viewportWin.style.height = '100%';
          viewportWin.style.maxWidth= '100%';
      },
      minimizeWindow: function(viewPort) {
         let viewportWin = document.getElementById(viewPort);
         viewportWin.style.display='none';
      },
      closeViewPort : function(viewPort) {
        let rootMenu = window.devStore.getRootMenuByViewPort(viewPort);
        window.BotServices.closeClient(rootMenu);
        let viewPortDiv = document.getElementById(viewPort);
        viewPortDiv.style.display = "none";
        window.devStore.DelFromPanelStack(viewPort);
        let lastActive = window.devStore.getLastActivePanel;
        if(lastActive) {
          let lastViewport = document.getElementById(lastActive)
          if(lastViewport) {
            lastViewport.style.display = "";
          } else {
            window.devStore.setLanding(true);
          }
        } else {
          window.devStore.setLanding(true);
        }
      },
      executeGraph(ClientID,EdgeObj) {
        let client = window.botStore.getClientByID(ClientID);
        let currentContext = JSON.parse(client.CurrentContext);
        let requestContext = currentContext;
      
        const GRAPHSERVER = '_FFFFFFFFFFFFFF00001684433717737647_';
        let params = {
          componentId : GRAPHSERVER,
          command : "ExecEdge",
          data : {"Node":EdgeObj.Node,"FormData":{"Name":EdgeObj.behaviourRowObj,"Results":EdgeObj.behaviourRowObj},"Context":currentContext},
          Type : 'BotApi'
        }
        console.log("ExecNode params",params);

        window.top.BotServices.callComponent(params, (err, result) => {
            if(result) {
                console.log("===result ExecNode===",result);
            }
        });
      },
      addMessageBox(viewportID, MessageBox) {
        console.log("dev mgr message bo");
        window.devStore.addMessageBox(viewportID, MessageBox);
        var Client = window.botStore.getClientByViewPort(viewportID);

        let InitialContext = JSON.parse(Client.InitialContext);

      /*  if(InitialContext && InitialContext.Email) {
          console.log("addEmailonMessageBox",viewportID,InitialContext.Email);
          MessageBox.addEmail(InitialContext.Email);
        //  window.devStore.addEmailonMessageBox(viewportID,InitialContext.Email);
        }

        if(InitialContext && InitialContext.PhoneNumber) {
          console.log("addPhoneonMessageBox",viewportID,InitialContext.PhoneNumber);
          MessageBox.addPhone(InitialContext.PhoneNumber);
          //window.devStore.addPhoneonMessageBox(viewportID,InitialContext.PhoneNumber);
        }*/
      },
      endcall : function(viewportid,client) {
        endcall(viewportid, client,window.devStore);
      },
      endParticipant : function(client,member) {
        endParticipant(client,member,window.devStore);
      },
      kickOutParticipant : function(client,member) {
        kickOutParticipant(client,member,window.devStore);
      },
      startRecording : function(viewportid,client) {
        startRecording(viewportid,client,window.devStore);
      },
      stopRecording : function(viewportid,client) {
        stopRecording(viewportid,client,window.devStore);
      },
      startMeeting : function (client,members) {
        console.log(" got event for start meeting for ",client,"===",members);
        let mode = "invite";let message = "";
       
        let inviteObj = {"to":{"tope":[],
                              "componentid":[],
                              "email":[],
                              "phone":[]},
                        "thread":client.ClientLeft,
                        "subject":client.ClientRight,
                        "ClientID" : client.Client,
                        "message":message,
                        "mode":mode,"callType":"MEETING","batchsize":'10',"dialerMode":"Meeting"};;

       
            members.forEach((label)=>{
              (inviteObj.to.tope).push(label.ToPE);
            });
       
        window.BotServices.callManagerExec(inviteObj,()=>{});
        let terminationUrl = {"MediaType":"Iframe","URL":"/GraphsApp/ReactMediaPlayerV1/index.html?clientID="+client.Client};
        window.BotServices.openChildPanel({ClientID : client.Client, DisplayName : 'Meeting', Termination : terminationUrl}, ()=>{});
      },
      stopMeeting:function (client) {
        console.log(" got event for stop meeting for ",client);
      },
      inviteParticipant:function (client,members) {
        console.log(" got event to invite participant for ",client,"===",members);
        let mode = "invite";let message = "";
       
        let inviteObj = {"to":{"tope":[],
                              "componentid":[],
                              "email":[],
                              "phone":[]},
                        "thread":client.ClientLeft,
                        "subject":client.ClientRight,
                        "ClientID" : client.Client,
                        "message":message,
                        "mode":mode,"callType":"MEETING","batchsize":'10',"dialerMode":"Meeting"};;

       
            members.forEach((label)=>{
              (inviteObj.to.tope).push(label.ToPE);
            });
       
        window.BotServices.callManagerExec(inviteObj,()=>{});

      },  
      startMedia : function(viewportid,client,params) {
        startMedia(viewportid,client,params,window.devStore);
      },
      openMediaPlayer : function(data) {
        mediaPlayer(data,window.devStore,ref,useDraggable);
      },
      openMediaPlayerWC : function(data) {
        mediaPlayer(data,window.devStore,ref,useDraggable);
      },
      openAlert : function(data) {
        this.$refs.devicemgr.openAlert(data);
      },
      hideAlert : function(data) {
        this.$refs.devicemgr.hideAlert(data);
      },
      openSaveMeetingPopup : function (client,viewport,store) {
        this.$refs.popup.showPopUp(client,viewport,store);
      },
      openDeepLinkPopup : function (client,viewport,store) {
        this.$refs.deepLinkPopup.showDeepLinkPopUp(client,viewport,store);
      },
      openMeetingLinksPopup :  function (client,viewport,store) {
        this.$refs.meetingLinksPopup.openmeetingLinksPopup(client,viewport,store);
      },
      openSimpliaPublishingPopup : function (client,viewport,store) {
        this.$refs.simpliaPublishingPopup.openPublishingPopup(client,viewport,store);
      },
      openMeetingInfoPopup : function(popObj) {
        console.log("openMeetingInfoPopup called");
        this.$refs.meetinginfopopup.showPopUp(popObj);
      },
      openWatchMeetingInfoPopup : function(popObj) {
        console.log("openWatchMeetingInfoPopup called");
        this.$refs.watchmeetinginfopopup.showPopUp(popObj);
      },
      openShowContextPopup : function(popObj) {
        console.log("openShowContextPopup called");
        this.$refs.contextinfopopup.showPopUp(popObj);
      },
      videoProgressStart :  function(popObj) {
        console.log("videoProgressStart called");
        const video = document.createElement('video');
        video.src = 'https://oxygencommunications.s3.amazonaws.com/recordings/ringtones/simpliademo.mp4';
        video.id = "mydemovideo";
        video.controls = true;
        video.muted = false;
        video.height = screen.height; // in px
        video.width = screen.width; // in px

        const box = document.getElementById('myvideo');
        box.appendChild(video);
        box.style.display = '';
        var demoelem = document.getElementById("mydemovideo");
        demoelem.autoplay = true;
        //demoelem.requestFullscreen();
      },
      videoProgressStop :  function(popObj) {
        console.log("videoProgressStop called");
        const box = document.getElementById('myvideo');
        box.style.display = 'none';
        var demoelem = document.getElementById("mydemovideo");
        if(demoelem)  {
          demoelem.autoplay = false;
          demoelem.src = '';
        }
      },
      SyncGoogleSheets: function(clientId,gsheetId,gid) {
          extractFromGSheet(clientId,gsheetId,gid);
      },
      RequestaServiceAction: function(clientId,event,inputStr) {
          console.log("Got request a service action",clientId,event,inputStr);
      },  
      OfferaServiceAction: function(clientId,event,inputStr) {
        console.log("Got offer a service action",clientId,event,inputStr);
      },
      confirmAgreement: function(clientId,params,viewportId) {
        console.log("Got confirm agreement request",clientId,params);
        //ConfirmAgreement(clientId,params,window.devStore);
        ConfirmRTablePost(clientId,viewportId,params,window.devStore);
        //window.CommApp.ConfirmAgreement(params,()=>{});
        //let terminationUrl = {"MediaType":"WebComponent",Template : 'oxygen-marketplace',"URL":url};
       // let url = "/ProviderSearch-0026/accept-form?formType=search&iframeClientId="+clientId+"&panelid="+clientId+"&what="+params.What+"&where="+params.Where+"&price="+params.Price+"&when="+params.When+"&Action="+params.Action+"&ActionType="+params.ActionType+"&SearchString="+params.SearchString+"&userType=consumer";
        //let terminationUrl = {"MediaType" : "Iframe","URL":url};
        //window.top.BotServices.openChildPanel({ClientID : clientId, DisplayName : 'Agreement', Termination : terminationUrl}, ()=>{});
      },
      ConfirmGlobalAgreement: function(clientId,viewportId,params) {
        console.log("Got confirm agreement request",clientId,viewportId,params);
        ConfirmGlobalAgreement(clientId,viewportId,params,window.devStore);
      },
      getLexAgrementInfo: function(SearchString,clientid,requestData,viewportId) {
        let newData = {};
        console.log("==params=lex==" +  SearchString);
        $.ajax({
          //url: "/NikhilAPythonApp-0020/System/ServerSide/index3",
          url: "https://debianlargeserver-0050-dataapps.laxroute53.com/MarketPlaceApp/System/ServerSide/index3",
          //url: "/MarketPlaceApp/System/ServerSide/index3",
          type: "POST",
          data: { text: SearchString, ans: "Agree" },
          success: (response) => {
            console.log("got agreement data");
            console.log(response);
            newData = {
              What: response.result.service,
              When: response.result.when,
              Where: response.result.LOCATION,
              Merit: response.result.merit,
              Coin: response.result.coin,
              Price: response.result.price,
              SearchString : SearchString,
              Action: requestData.Action,
              ActionType: requestData.ActionType
              //Price: response.result.QUANTITY
            };
            console.log("New Data " + JSON.stringify(newData));
            let srcData =
              "/ProviderSearch-0026/search-form?clientid="+clientid+"&formType=search&iframeClientId=_FFFFFFFFFFFFFF00001598133142878018_&panelid=id_74148583301d71f45b79041508c9474c&what=" +
              newData.What +
              "&where=" +
              newData.Where +
              "&price=" +
              newData.Price +
              "&merit=" +
              newData.Merit +
              "&point=" +
              newData.Coin +
              "&when=" +
              newData.When +
              "&Action=" +
              requestData.Action +
              "&ActionType=" +
              requestData.ActionType +
              "&SearchString=" +
              SearchString;
            console.log("===url==" + srcData);
             // Example usage:
             //this.createPopupWithIframe(srcData);
             CreateConversationPost(viewportId, clientId,newData, window.devStore);
             //let paramsObj = {Action: requestData.Action,ActionType: requestData.ActionType,Address: "",Category: "",Distance: "",GraphTemplateDN: "Simplia Jobs-0041",GraphTemplateID: "_FFFFFFFFFFFFFF00001734442698241486_/11admin1_FFFFFFFFFFFFFF00001731965965540235_1Editor1_FFFFFFFFFFFFFF00001734442698241486_",Location: {lat: 30.5190775, lon: -91.5208624},Merit: newData.Merit,Name: "",Point: newData.Coin,PostName: newData.What,Price: newData.Price,ST: null,SearchString:SearchString,Title: newData.What,What: newData.What,When: newData.When,Where: newData.Where,size: 10};
             //ConfirmRTablePost(clientId,viewportId,paramsObj,window.devStore);
          },
        });
      },
      createMarketplacePost: function(clientId,viewportId,inputStr,ActionType) {
        console.log("Got create marketplace post request",clientId,viewportId,inputStr,ActionType);
        let inputStrVal = "";let requestData = {};
        let client = window.botStore.getClientByID(clientId);

        if (inputStr && inputStr.__v_isRef === true) {
          inputStrVal =  inputStr.value;
        } else {
          inputStrVal = inputStr;
        }
        
         if(client.ClientRightRole  == 'Customer') {
            requestData.PostRole = 'Customer';
            requestData.Action = "RequestService";
            requestData.ActionType = ActionType;
         } else if(client.ClientRightRole == 'Provider' || client.ClientRightRole == 'admin') {
            requestData.PostRole = 'Provider';
            requestData.Action = "OfferService";
            requestData.ActionType = ActionType;
         }
   
        this.getLexAgrementInfo(inputStrVal,clientId,requestData,viewportId);
      },
      createPopupWithIframe : function(url) {
        // Remove existing popup if it already exists
        const existing = document.getElementById("iframePopup");
        if (existing) existing.remove();

        // Create popup overlay
        const popup = document.createElement("div");
        popup.id = "iframePopup";
        popup.style.cssText = `
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(0,0,0,0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99999;
        `;

        // Create popup content container
        const content = document.createElement("div");
        content.style.cssText = `
          position: relative;
          background: white;
          width: 90%;
          max-width: 800px;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        `;

        // Close button
        const closeBtn = document.createElement("span");
        closeBtn.innerHTML = "&times;";
        closeBtn.style.cssText = `
          position: absolute;
          top: 8px;
          right: 12px;
          font-size: 24px;
          cursor: pointer;
          z-index: 10;
        `;
        closeBtn.onclick = () => document.body.removeChild(popup);

        // Spinner wrapper (above everything)
        const loader = document.createElement("div");
        loader.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 48px;
          height: 48px;
          border: 5px solid #ccc;
          border-top: 5px solid #4f46e5;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          z-index: 9;
          background: white;
        `;

        // Spinner animation style
        const style = document.createElement("style");
        style.innerHTML = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `;
        document.head.appendChild(style);

        // Responsive iframe wrapper
        const iframeWrapper = document.createElement("div");
        iframeWrapper.style.cssText = `
          position: relative;
          width: 100%;
          padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
          height: 0;
        `;

        // Iframe
        const iframe = document.createElement("iframe");
        iframe.src = url;
        iframe.style.cssText = `
          position: absolute;
          top: 0; left: 0;
          width: 100%;
          height: 100%;
          border: none;
          z-index: 5;
        `;
        iframe.allowFullscreen = true;

        // Hide loader when iframe loads
        iframe.onload = () => {
          loader.style.display = "none";
        };

        // Assemble everything
        iframeWrapper.appendChild(iframe);
        content.appendChild(closeBtn);
        content.appendChild(loader);
        content.appendChild(iframeWrapper);
        popup.appendChild(content);
        document.body.appendChild(popup);

        // ✅ Auto-close the popup after 3 minutes (180000 ms)
        setTimeout(() => {
          if (popup && popup.parentNode) {
            popup.parentNode.removeChild(popup);
          }
        }, 70000);
      },
     createPopupWithIframeOld : function(url) {
        // Remove existing popup if it already exists
        const existing = document.getElementById("iframePopup");
        if (existing) existing.remove();

        // Create popup overlay
        const popup = document.createElement("div");
        popup.id = "iframePopup";
        popup.style.cssText = `
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(0,0,0,0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99999;
        `;

        // Create popup content
        const content = document.createElement("div");
        content.style.cssText = `
          position: relative;
          background: white;
          width: 90%;
          max-width: 800px;
          border-radius: 10px;
          overflow: hidden;
          padding: 1rem;
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        `;

        // Close button
        const closeBtn = document.createElement("span");
        closeBtn.innerHTML = "&times;";
        closeBtn.style.cssText = `
          position: absolute;
          top: 8px;
          right: 12px;
          font-size: 24px;
          cursor: pointer;
          z-index: 2;
        `;
        closeBtn.onclick = () => document.body.removeChild(popup);

        // Centered loader/spinner
        const loader = document.createElement("div");
        loader.className = "popup-spinner";
        loader.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          width: 40px;
          height: 40px;
          margin: -20px 0 0 -20px;
          border: 4px solid #ddd;
          border-top: 4px solid #4f46e5;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          z-index: 1;
        `;

        // Add spinner animation style
        const style = document.createElement("style");
        style.innerHTML = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `;
        document.head.appendChild(style);

        // Responsive iframe wrapper
        const iframeWrapper = document.createElement("div");
        iframeWrapper.style.cssText = `
          position: relative;
          width: 100%;
          padding-bottom: 56.25%;
          height: 0;
        `;

        // Iframe
        const iframe = document.createElement("iframe");
        iframe.src = url;
        iframe.style.cssText = `
          position: absolute;
          top: 0; left: 0;
          width: 100%;
          height: 100%;
          border: none;
          z-index: 2;
        `;
        iframe.allowFullscreen = true;

        // Hide loader when iframe loads
        iframe.onload = () => {
          loader.style.display = "none";
        };

        // Build popup
        iframeWrapper.appendChild(iframe);
        content.appendChild(closeBtn);
        content.appendChild(loader);
        content.appendChild(iframeWrapper);
        popup.appendChild(content);
        document.body.appendChild(popup);
      },
      getProviderInfotoCall : function(clientId,params) {
        console.log("Got provider agreement request",clientId,params);
        if(params && params.ArgJSON) {
          let data = JSON.parse(params.ArgJSON);
          let agreementData = {"What":data.Post,"When":data.PostTime,"Where":data.PostLocation,"Price":data.PostPrice,"ContactName":data.ContactName,"Location":data.Location,"Distance":data.Distance,"ActionType":data.ActionType,Action: data.Action,SearchString: data.SearchString};
          console.log("==providr call agreementData",agreementData);
          getProviderDatatoCall(agreementData,params,clientId);
        }
      },
      acceptedByProvider: function(clientId,params) {
        console.log("Got Accepted By Provider",clientId,params);
        grantTransaction();
      },
      acceptedByConsumer: function(clientId,params) {
        console.log("Got Accepted By Consumer",clientId,params);
        grantTransaction();
      },
      cancelAgreement: function(clientId, params) {
        console.log("Got confirm agreement request",clientId,params);
      },
      openSetPhoneNumberPopup : function(client,viewport,store) {
        console.log("openSetPhoneNumberPopup called");
        this.$refs.setphonenumberpopup.showPopUp(client,viewport,store);
      },
      openSetEmailAddressPopup : function(client,viewport,store) {
        console.log("openSetEmailAddressPopup called");
        this.$refs.setemailaddress.showPopUp(client,viewport,store);
      },
      openSetOxygenNumberPopup : function(client,viewport,store) {
        console.log("openSetOxygenNumberPopup called");
        //this.$refs.setoxygennumber.showPopUp(client,viewport,store);
      },
      openDeskListPopup : function(popObj) {
        console.log("openDeskListPopup called",popObj);
        this.$refs.desklistpopup.showPopUp(popObj);
      },
      openImportTablePopup : function(popObj) {
        console.log("openImportTablePopup called",popObj);
        this.$refs.ImportTablepopup.showPopUp(popObj);
      },
      openDeviceStreamPopup : function(popObj) {
        console.log("openDeviceStreamPopup called");
        this.$refs.devicestreampopup.showPopUp(popObj);
      },
      saveMeeting : function(meetingName,subjectFlag,client) {
       console.log("got save meeting called",meetingName,subjectFlag,client);
      },
      setMeeting : function(clientId,meetingName) {
        console.log("got set meeting called",meetingName);
        let client = window.botStore.getClientByID(clientId);
        let meetingObj = JSON.parse(client.MeetingContext);
        let currentContext = JSON.parse(client.CurrentContext);
        currentContext.MeetingName = meetingName;
        currentContext.MeetingParentId = meetingObj.MeetingParentId;
        meetingObj.LeftRole  = client.ClientLeftRole;
        meetingObj.LeftID = client.ClientLeft;
        meetingObj.RightRole = client.ClientRightRole;
        meetingObj.RightID = client.ClientRight;
        meetingObj.MeetingName = meetingName;
        meetingObj.currentContext = currentContext;
        window.CommApp.saveMeeting(currentContext, (err, res) => {});
      },
      showSwitchRole: function() {
        console.log("showSwitchRole called");
        this.$refs.switchrolepopup.showPopUp();
      }
  },
  mounted() {
      console.log("Device Manager mounted new ");
      const devMgrLoaded = new Event('devMgrLoaded');
      window.dispatchEvent(devMgrLoaded );
  },
  setup () {
      const store = deviceStore();
      //loadLandingPage();

      window.devStore = store;
      const viewPorts = ref(store.viewPorts);
      const terminationPoints = ref(store.terminationPoints);
      const addHeaderRightIcons = ref(store.addHeaderRightIcons);
      const addHeaderLeftIcons = ref(store.addHeaderLeftIcons);
      const rootMenu = ref(store.rootMenu);
      const clients = ref(store.clients);
      const panelStack = ref(store.panelStack);
      store.createTerminations = createTerminations;

      watch(
          clients,
          async ()=>{

            let landingPageClient = clients.value.find(e => e.IsLanding);
            if(landingPageClient && !landingPageClient.clientEventsSet) {
              console.log('watch-clients', 'setting up landingPage client events');
              landingPageClient.clientEventsSet = true;


              window.geoip2.city(async (location) => {
                window.LivingScript_0070.globalContext.geolocation = location;
                setupClientEvents(landingPageClient);
                console.log('watch-clients','location:', window.LivingScript_0070.globalContext.geolocation);
                //await oxygenUtil.recordAnalyticsEvent('SessionStart', { segmentId: landingPageClient.historyData.SegmentId }, landingPageClient.historyData);
                //$('#app').focus();
              });

            }
          },
          {
            deep: true,
            immediate: true
          }
      )

      function setupClientEvents(client) {
        console.log('setupClientEvents', 'client:', client, ' element:', $('#app')[0]);
        if($('#app')[0]) {
          $('#app')[0].tabIndex = -1;

          oxygenUtil.setHistoryData(client);
          oxygenUtil.setupClientEventsListeners($('#app')[0], client);
        }

      }

      watch(() => [...viewPorts.value], (newViewport, oldViewport) => {
        let addedViewports = newViewport.filter(viewport => !oldViewport.includes(viewport));
        createVuePortDraggables(addedViewports);
        setInitialContext(addedViewports);
      });

      watch(() => [...terminationPoints.value], (newTermination, oldTermination) => {
        let addedTerminations = newTermination.filter(termination => !oldTermination.includes(termination));
        createTerminations(addedTerminations);
      });

      watch(() => [...addHeaderLeftIcons.value], (newLeftIcon, oldLeftIcon) => {
        let addedLeftIcons = newLeftIcon.filter(LeftIconID => !oldLeftIcon.includes(LeftIconID));
        createHeaderLeftRibbon(addedLeftIcons);
      });

      watch(() => [...addHeaderRightIcons.value], (newRightIcon, oldRightIcon) => {
        let addedRightIcons = newRightIcon.filter(RightIconID => !oldRightIcon.includes(RightIconID));
        createHeaderRightRibbon(addedRightIcons);
      });

      watch(() => [...rootMenu.value], (newMenu, oldMenu) => {
        let addMenu = newMenu.filter(menuItem => !oldMenu.includes(menuItem));
        if(addMenu && addMenu.length > 0) {
          //window.BotServices.rootMenuApi({Action : 'addRootMenu', Data : addMenu}, ()=>{});
        }
        window.BotServices.Events.next({RootMenu: newMenu});
        let delMenu = oldMenu.filter(menuItem => !newMenu.includes(menuItem));

        if(delMenu && delMenu.length > 0) {
          //window.BotServices.rootMenuApi({Action : 'delRootMenu', Data : delMenu}, ()=>{});
        }
      });

      watch(() => [...panelStack.value], (newStack, oldStack) => {
        if(window.botStore.settings.Overlay == true && newStack && newStack.length > 0) {
          document.getElementById("dmoverlay").style.display = "block";
        } else {
          document.getElementById("dmoverlay").style.display = "none";
        }
      });
      
      async function createHeaderLeftRibbon(createHeaderLeftRibbon) {
         console.log("createHeaderLeftRibbon :", createHeaderLeftRibbon);
         //store.addHeaderLeftIcon({LeftIconID:1238 ,class:"fa fa-fw fa-phone",title:"test Icon"});
      }

      async function createHeaderRightRibbon(createHeaderRightRibbon) {
         console.log("createHeaderRightRibbon :", createHeaderRightRibbon);
      }

      function openClientTermination(termination) {
          if(termination.Template) {
            window.BotServices.openClient({ContainerID : termination.terminationID,viewportID:termination.viewportID,ClientID:termination.ClientID, URL: termination.URL, MediaType: termination.MediaType,Template:termination.Template,dataset:termination.dataset,Elements : (termination.Elements) ? termination.Elements : null});
          } else {
            window.BotServices.openClient({ContainerID : termination.terminationID,viewportID:termination.viewportID,ClientID:termination.ClientID, URL: termination.URL, MediaType: termination.MediaType,dataset:termination.dataset,Elements : (termination.Elements) ? termination.Elements : null});
          }
      }

      async function createTerminations(newTerminations) {
        await nextTick();
        newTerminations.forEach((termination) => {
        let viewdomid = document.getElementById(termination.viewportID);
        //viewdomid.style.overflow  = "scroll";

        if(termination.MediaType == 'WebComponent') {
            openClientTermination(termination);
        } else if(termination.MediaType == 'WebComponentLP') {
            let viewport = document.getElementById(termination.viewportID);

            var x = document.createElement("IMG");
            x.setAttribute("src", "https://debianlargeserver-0050-kamalk-0054.laxroute53.com/imgs/business_funnel.png");
            x.setAttribute("width", "500px");
            x.setAttribute("height", "500px");
            x.setAttribute("alt", "Simplia");
            x.setAttribute("class", "w3-round");
            x.setAttribute("style", "display: block;vertical-align: middle;max-width: 100%;height: auto;margin-top:100px;margin-left:33%");
            viewport.appendChild(x);
       } else if (termination.MediaType == 'Video') {
            navigator.mediaDevices.getUserMedia({ audio: false, video: true })
              .then(function(stream) {
                console.log("Stream", stream);
                let viewport = document.getElementById(termination.viewportID);
                const videoElement = document.createElement("VIDEO");
                videoElement.srcObject = stream;
                videoElement.onloadedmetadata = function(e) {
                  videoElement.play();
                };
                videoElement.autoplay = true;
                videoElement.controls = true;
                videoElement.muted = true;
                //videoElement.height = 240; // 👈️ in px
                //videoElement.width = 320;
                videoElement.style.height = '100%';
                videoElement.style.width = '100%';
                viewport.appendChild(videoElement);
              /* use the stream */
              })
              .catch(function(err) {
                console.log("Err", err);
              /* handle the error */
              });
          } else if (termination.MediaType == 'Iframe') {
              window.BotServices.openClient({ContainerID : termination.terminationID, viewportID:termination.viewportID,URL: termination.URL, MediaType: termination.MediaType,dataset:termination.dataset,Elements : (termination.Elements) ? termination.Elements : null});
              /*let viewport = document.getElementById(termination.viewportID);
              var iframeElement = document.createElement("IFRAME");
               iframeElement.id = "iframe_"+termination.terminationID;
               iframeElement.src = termination.URL;
               iframeElement.scrolling = "no";
               iframeElement.frameborder = "0";
               iframeElement.style.border= "none";
               iframeElement.style.width = '100%';
               iframeElement.style.height = '900px';
               //iframeElement.style.height = '100%';
               viewport.appendChild(iframeElement);
               var iframe = document.getElementById("iframe_"+termination.terminationID);
               iframe.onload = function() {
                  if(termination.DisplayState != 'Media') {
                    iframe.style.height = iframe.contentWindow.document.body.scrollHeight + 'px';
                  } else {
                    iframe.style.height = "500px";
                  }

               }*/
          }
        });
      }

      async function createVuePortDraggables(newViewports) {
        console.log('newViewports:', newViewports);
        await nextTick();
        await nextTick();
        await nextTick();
        //$(function() {
          //  $(".draggable").draggable();

        //});
        newViewports.forEach((viewPort) => {
            let domId = viewPort.viewportID;
            let viewPortElement = window.document.getElementById(domId);
            if(viewPortElement) {
            createHeaderIcons(viewPort.ClientID,domId,store);
            createRightMenuOptions(viewPort.ClientID,domId,store);

            //console.log("viewPortElement : ", viewPortElement);
            if(store.isLanding) {
              console.log("Is landing");
              viewPortElement.style.width  =  viewPort.Width;
              viewPortElement.style.height =  viewPort.Height;
            } else {
               viewPortElement.style.width  =  viewPort.Width;
               viewPortElement.style.height =  viewPort.Height;
               viewPortElement.style.border =  "1px solid lightgray";
            }
            if(viewPort.Height != viewPort.Width) {
                //viewPortElement.style.overflow = "scroll";
            }
            if(viewPort.Position) {
              viewPortElement.style.position = viewPort.Position;
            } else {
              viewPortElement.style.position = "fixed";
            }
            viewPortElement.style.left  = viewPort.TopRightY;
            viewPortElement.style.top = viewPort.TopLeftX;
            viewPortElement.style.zoom = viewPort.Zoom;
            if(viewPort.DisplayState == "Landing") {
              viewPortElement.style.height =  '25px';
              if(store.isLanding == true) {
                viewPortElement.style.background = 'transparent';
              } else {
                viewPortElement.style.background = 'white';
              }
              //store.addTerminationPoint({viewportID:domId,terminationID : window.LivingScript_0070.guid.generateSync(), MediaType : 'Inline',URL:'<LandingPage />'});
            } else if(viewPort.DisplayState == "WhiteBoard") {
              viewPortElement.style.background = 'white';
              store.addTerminationPoint({viewportID:domId, terminationID : window.LivingScript_0070.guid.generateSync(), MediaType : 'Iframe',URL:'/MessagingService/yjswb/test/index.html?meeting='+window.LivingScript_0070.guid.generateSync()});
            } else {
                viewPortElement.style.background = 'white';
            }
            }
        });
      }

      function setInitialContext(newViewports) {
        console.log("setInitialContext : ", newViewports);
        newViewports.forEach((viewPort) => {
          if(viewPort.MessageBox) {
            let Client = window.botStore.getClientByViewPort(viewPort.viewportID);
            if(Client) {
              let InitialContext = JSON.parse(Client.InitialContext);
              if(InitialContext && InitialContext.Email) {
                window.DevMgr.addEmailonMessageBox(viewPort.viewportID, InitialContext.Email);
              }

              if(InitialContext && InitialContext.PhoneNumber) {
                window.DevMgr.addPhoneonMessageBox(viewPort.viewportID, InitialContext.PhoneNumber);
              }
            }
          }
        });
      }

      function RegisterToHistory(params) {
        console.log("Got params to RegisterToHistory",params);
        $.ajax({
          type:"POST",
          url:"/as/_FFFFFFFFFFFFFF20170326103602132008_/at/_FFFFFFFFFFFFFF20170326103602132008_/module/history-module/api/register",
          data: {ClientID:params.ClientID,GrantID:params.GrantID,Token:params.Token},
          dataType:"json",
          success: function(data) {
              console.log("Got HTTP Response Register");
              console.log(data);
              if(data && data.status == "Registration successful") {
                  AddToHistory(params);
              }
            }
          });
      }

      function AddToHistory(params) {
        console.log("Got params to addToHistory",params);
        $.ajax({
          type:"POST",
          url:"/as/_FFFFFFFFFFFFFF20170326103602132008_/at/_FFFFFFFFFFFFFF20170326103602132008_/module/history-module/api/add",
          data: {ClientID:params.ClientID,GrantID:params.GrantID,Token:params.Token},
          dataType:"json",
          success: function(data) {
              console.log("Got HTTP Response Add");
              console.log(data);
            }
          });
      }

      function appendChild(container) {
        var getPage = new XMLHttpRequest();
        getPage.addEventListener("load", () => {
          const doc = document.createRange().createContextualFragment(getPage.responseText);
          container.appendChild(doc);
        });
        getPage.open("GET", 'https://debianlargeserver-0050-kamalk-0054.laxroute53.com/BotServices/app/SimpliaV2');
        getPage.send();
    }

    async function loadLandingPage() {
        let clientObj = {clientID:"12345"};
        store.addClient(clientObj);

        await nextTick();
        let newViewport = {
          viewportID : window.LivingScript_0070.guid.generateSync(),
          ClientID : clientObj.clientID,
          MeetingPath : '/',
          ClientPath : '/Root/',
          TopLeftX : "0px",
          TopRightY : "0px",
          ZIndex : 1000,
          Width:"100%",
          Height:"25px",
          PanelTitle: 'SimpliaHome',
          DisplayState : 'Landing',
          isLanding : true
        }

        store.addViewPort(newViewport);
    }

    if(window.BotServices && window.BotServices.Events) {
      botStoreSubscribe();
    } else {
      window.addEventListener("botServicesLoaded", (event) => {
        botStoreSubscribe();
      });
    }

    function botStoreSubscribe() {
      window.BotServices.Events.subscribe({
        next : ((event) => {
          console.log("got subscribe event");
          if(event.Clients && event.Clients.length > 0) {
            event.Clients.forEach((client) => {
              client.clientID = client.Client;
              store.addClient(client);
              store.initBehaviour(client);
             // getBehaviours(client, store);
             if(client.IsLanding) {
                addLandingPage(client, store);
              } else {
                if(client.MenuPath) {
                  openClientPage(client.MenuPath, store);
                } else {
                  addClientPage(client, store);
                }
              }
            });
          } else if(event.Triggers) {
             console.log("Got client trigger",event.Triggers);
             if(event.Triggers.Type == "Behaviour" && event.Triggers.Data && event.Triggers.Data.ClientID) {
                let clientObj = window.botStore.getClientByID(event.Triggers.Data.ClientID);
                if(clientObj) {
                    //getBehaviours(clientObj, store);
                    //store.initBehaviour(clientObj);
                }
             }
             if(event.Triggers.Type == "DeskTrigger" && event.Triggers.Data && event.Triggers.Data.Client) {
                let clientObj = window.botStore.getClientByID(event.Triggers.Data.Client);
                if(clientObj) {
                    console.log("==event triiger node",event.Triggers.Data.Node);
                    GetNodeDeskGraph(clientObj, event.Triggers.Data.Node,store);
                    store.initBehaviour(clientObj);
                }
             }
          }
        }),
      });
    }
    return { store, viewPorts };
  }
}
</script>

<template>
  <main>
    <div id="oxygen-devices" class="oxygen-devices" autofocus>

       <FullScreenHeader  name="oxygen-fullheader" v-if="store.isLanding == true"></FullScreenHeader>
       <simplia-signin id="simplia-Signin"></simplia-signin>
       <Containers name="oxygen-container" ref="devicemgr"></Containers>
       <SwitchRolePopup ref="switchrolepopup"></SwitchRolePopup>
       <MeetingPopup ref="popup"></MeetingPopup>
       <PhoneNumberPopup ref="setphonenumberpopup"></PhoneNumberPopup>
       <EmailAddressPopup ref="setemailaddress"></EmailAddressPopup>
       <!--<OxygenNumberPopup ref="setoxygennumber"></OxygenNumberPopup>-->
       <meetinginfopopup ref="meetinginfopopup"></meetinginfopopup>
       <watchmeetinginfopopup ref="watchmeetinginfopopup"></watchmeetinginfopopup>
       <deviceStream ref="devicestreampopup"></deviceStream>
       <deskList ref="desklistpopup"></deskList>
       <ImportTable ref="ImportTablepopup"></ImportTable>
       <DeepLinkPopup ref="deepLinkPopup"></DeepLinkPopup>
       <PublishingLink ref="simpliaPublishingPopup"></PublishingLink>
       <meetingLinks ref="meetingLinksPopup"></meetingLinks>
       <contextinfopopup red="contextinfopopup"></contextinfopopup>
    </div>
      <div style="position: absolute; left: -100vw; width: 100vw;">
      <div id="pdfOutput">
        <img id="pdfContentImg" src="" alt="" width="100" height="100" >
      </div>
    </div>
  </main>
</template>

<style>
/*@import '@fontawesome/fontawesome-pro/css/all.css';*/
@import './assets/jquery-ui.css';
@import './assets/style.css';

</style>
